





import AccountSettings from '@/mixins/accountSettings.mixin';
import { Mixins, Component } from 'vue-property-decorator';

@Component({
})
export default class LogoutCallbackComponent extends Mixins(AccountSettings) {
  beforeMount() {
    const slug = localStorage.getItem('slug');
    window.location.href = `${window.location.origin}/${slug}/#/login`;
  }
}
